export const serverUrl = process.env.REACT_APP_SERVER_URL;
export const showRewardsProgram = process.env.REACT_APP_SHOW_REWARDS_PROGRAM;
export const bookingSource = process.env.REACT_APP_BOOKING_SOURCE;
export const posAppId = process.env.REACT_APP_POS_APP_ID;
export const posTillNo = process.env.REACT_APP_POS_TILL_NO;
export const channel = process.env.REACT_APP_CHANNEL;
export const kiosk_terminal = process.env.REACT_APP_TERMINAL;
export const kiosk_sector = process.env.REACT_APP_SECTOR;
export const kiosk_movementType = process.env.REACT_APP_MOVEMENT_TYPE;
export const showDeliverToGate = process.env.REACT_APP_SHOW_DEL_TO_GATE;
export const hideDelSelectionPostStart =
  process.env.REACT_APP_HIDE_DEL_SELECTION_POST_START;
export const callPromoApi = process.env.REACT_APP_CALL_PROMO_API;
export const empPin = process.env.REACT_APP_EMP_PIN;
export const showPulseQrCode = process.env.REACT_APP_SHOW_PULSE_QR_CODE;
export const pulseQrCode = process.env.REACT_APP_PULSE_QR_CODE;
